<div class="header">
  <div>
    <h2>{{ 'menu.admin.organisations' | translate }}</h2>
  </div>
  <!-- Shared search field (same component as Audit / Guardrails / KB).
       `app-table` has no search of its own, so the page filters. -->
  <div class="filters">
    <app-search-input
      [value]="search"
      (valueChange)="onSearchChange($event)"
      placeholderKey="pages.admin.organisations.searchPlaceholder"
    ></app-search-input>

    <button
      *ngIf="isSuperAdmin"
      nbButton
      status="primary"
      size="small"
      (click)="impersonateMaster()"
    >
      <nb-icon icon="people-outline"></nb-icon>
      {{ 'buttons.impersonateMaster' | translate }}
    </button>
  </div>
</div>

<nb-card>
  <nb-card-body>
    <!-- Deleting an organisation runs for many seconds on the server. The
         table is hidden (not removed: selection and #table stay alive) so
         nothing can be triggered a second time. CLAUDE.md Regel 19, Stufe C. -->
    <app-orbi-loader
      *ngIf="deleting"
      class="deleting-loader"
      [label]="
        'pages.admin.organisations.deleting' | translate: { count: deletingCount }
      "
    ></app-orbi-loader>
    <app-table
      #table
      [hidden]="deleting"
      rowIdKey="id"
      [nbSpinner]="loading"
      [title]="title"
      [columns]="columns"
      [data]="filteredData"
      [rowActions]="rowActions"
      [globalActions]="globalActions"
      (event)="onEvent($event)"
      [options]="{ resetPageOnDataChange: false }"
      [maxVisibleItems]="500"
    ></app-table
  ></nb-card-body>
</nb-card>
